<app-modal [active]="displayed" (modalClosed)="displayed = false;closeContactForm()">
  <div class="container">
    <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg" timeOut="0" display="true"
                      error=true></app-notification>
    <div class="info__box" *ngIf="!requestDocumentPriceName && !isRegisterComponent">
      <div class="columns">
        <div class="column is-1 pl-0 pt-1 mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
               width="46" height="40" x="0" y="0" viewBox="0 0 488.9 488.9"
               xml:space="preserve" class="">
              <g>
                <g xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="M239.15,0c31.9,0,57.7,25.8,57.7,57.7s-25.8,57.7-57.7,57.7s-57.7-25.8-57.7-57.7S207.25,0,239.15,0z M291.65,151.6h-1.5    h-92.8h-3.4c-19,0-34.3,15.4-34.3,34.3l0,0c0,19,15.4,34.3,34.3,34.3h3.4v200h-37.7v68.7h169.6v-68.7h-37.5V151.6H291.65z"
                      fill="#35566e" data-original="#000000"/>
                  </g>
                </g>
              </g>
            </svg>
        </div>
        <div class="column">
          <h2 class="title is-5">
            Kontakt:
          </h2>
          <p>
            Als Gewerbekunde haben Sie Zugriff auf unser vollumfängliches Sortiment. Gerne schauen wir welche unsere
            Lösungen am besten zu Ihrem Bedarf passt. Mehr erfahren Sie hier oder kontaktieren Sie uns gleich:
          </p>
        </div>
      </div>
    </div>
    <form [formGroup]="contactForm">

      <div class="title">Kontakt aufnehmen</div>
      <input [ngClass]="{'has-error': hasError(contactForm.get('firstName'))}" class="input"
             [placeholder]="hasRequiredValidator(contactForm.get('firstName')) ? 'Vorname*' : 'Vorname'"
             formControlName="firstName">

      <input [ngClass]="{'has-error': hasError(contactForm.get('name'))}" class="input"
             [placeholder]="hasRequiredValidator(contactForm.get('name')) ? 'Nachname*' : 'Nachname'"
             formControlName="name">

      <input [ngClass]="{'has-error': hasError(contactForm.get('company'))}" class="input"
             [placeholder]="hasRequiredValidator(contactForm.get('company')) ? 'Unternehmen*' : 'Unternehmen'"
             formControlName="company">

      <input [ngClass]="{'has-error': hasError(contactForm.get('mail'))}" class="input"
             [placeholder]="hasRequiredValidator(contactForm.get('mail')) ? 'E-Mail*' : 'E-Mail'"
             formControlName="mail">

      <input class="input" formControlName="phone" placeholder="Telefon">

      <textarea [ngClass]="{'has-error': hasError(contactForm.get('text'))}" class="textarea mt-4"
                [placeholder]="hasRequiredValidator(contactForm.get('text')) ? 'Ihr Anliegen*' : 'Ihr Anliegen'"
                cols="5"
                formControlName="text"
                rows="5">
      </textarea>
      <button class="button is-transparent mt-5" (click)="requestMail()">Abschicken</button>
    </form>
  </div>
</app-modal>
